<a class="ag-link" (click)="navigate()" style="cursor:pointer;">
  {{ displayValue }}
</a>

